import { render } from "./AccordionProductGroup.vue?vue&type=template&id=46ab2b57"
import script from "./AccordionProductGroup.vue?vue&type=script&lang=js"
export * from "./AccordionProductGroup.vue?vue&type=script&lang=js"

import "./AccordionProductGroup.vue?vue&type=style&index=0&id=46ab2b57&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__